export default 'logged_user';

//# sourceMappingURL=key.js.map